import React, { useContext } from 'react';

import { media } from 'context';
import { Icon, Layout, Link, Text } from 'ds';
import { CLEANING_SERVICE_PATH } from 'routes';

interface Props {}

const CleaningServiceWidget: React.FC<Props> = () => {
  const { isMobile } = useContext(media);
  if (isMobile) {
    return (
      <Link href={CLEANING_SERVICE_PATH} color="black" fullWidth fullHeight>
        <Layout
          direction="row"
          align="flex-end"
          justify="space-between"
          borderRadius={16}
          padding={12}
          color="white"
          gap={8}
          height="100%"
        >
          <Text size="body-xs" color="purple-gradient" semibold __style={{ verticalAlign: 'bottom' }}>
            Set up your cleaning service
          </Text>
          <Icon name="rightChevron" color="purple-gradient" size={30} />
        </Layout>
      </Link>
    );
  }
  return (
    <Link href={CLEANING_SERVICE_PATH} color="black" fullWidth fullHeight>
      <Layout
        direction="column"
        align="center"
        justify="center"
        gap={16}
        borderRadius={16}
        padding={16}
        color="white"
        height="100%"
      >
        <Layout direction="column" align="center" gap={4}>
          <Icon name="featherDuster" color="purple-gradient" size={32} />
          <Text size="body-md" color="purple-gradient" align="center" semibold>
            A cleaner office is just a click away.
          </Text>
        </Layout>
        <Layout borderRadius={16} color="purple-gradient" paddingX={12} paddingY={4} display="inline-flex">
          <Text size="body-xs" color="white" semibold>
            Add a cleaning
          </Text>
        </Layout>
      </Layout>
    </Link>
  );
};

export default CleaningServiceWidget;
